<template>
  <div class="px-4 md:px-10 mx-auto w-full py-8">
    <div class="max-w-lg mx-auto">
      <h2 class="text-2xl font-bold text-gray-700 mb-6">Account Settings</h2>

      <!-- User info -->
      <div class="bg-white rounded-xl shadow p-6 mb-6">
        <h3 class="text-sm uppercase font-bold text-gray-500 mb-3">Account</h3>
        <div class="text-sm text-gray-700">
          <span class="font-semibold">Email:</span> {{ user.email }}
        </div>
        <div v-if="user.name" class="text-sm text-gray-700 mt-1">
          <span class="font-semibold">Name:</span> {{ user.name }}
        </div>
      </div>

      <!-- Change password form -->
      <div class="bg-white rounded-xl shadow p-6">
        <h3 class="text-sm uppercase font-bold text-gray-500 mb-4">Change Password</h3>

        <div
          v-if="successMsg"
          class="mb-4 px-4 py-3 rounded-lg bg-green-50 text-green-700 text-sm flex items-center gap-2"
        >
          <i class="fas fa-check-circle"></i>
          {{ successMsg }}
        </div>
        <div
          v-if="errorMsg"
          class="mb-4 px-4 py-3 rounded-lg bg-red-50 text-red-600 text-sm flex items-center gap-2"
        >
          <i class="fas fa-exclamation-circle"></i>
          {{ errorMsg }}
        </div>

        <form @submit.prevent="submit">
          <div class="mb-4">
            <label class="block text-xs font-bold text-gray-600 mb-1 uppercase">
              Current Password
            </label>
            <input
              v-model="form.currentPassword"
              type="password"
              autocomplete="current-password"
              class="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-respina-primary"
              placeholder="Enter current password"
              required
            />
          </div>
          <div class="mb-4">
            <label class="block text-xs font-bold text-gray-600 mb-1 uppercase">
              New Password
            </label>
            <input
              v-model="form.newPassword"
              type="password"
              autocomplete="new-password"
              class="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-respina-primary"
              placeholder="At least 6 characters"
              required
            />
          </div>
          <div class="mb-6">
            <label class="block text-xs font-bold text-gray-600 mb-1 uppercase">
              Confirm New Password
            </label>
            <input
              v-model="form.confirmPassword"
              type="password"
              autocomplete="new-password"
              class="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-respina-primary"
              placeholder="Repeat new password"
              required
            />
          </div>

          <button
            type="submit"
            :disabled="loading"
            class="w-full py-2 px-4 rounded-lg text-sm font-bold text-white bg-respina-primary hover:bg-respina-secondary transition-colors"
            :class="{ 'opacity-50 cursor-not-allowed': loading }"
          >
            <i v-if="loading" class="fas fa-spinner fa-spin mr-2"></i>
            {{ loading ? 'Saving...' : 'Change Password' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from '@/lib/auth';
import { changePassword } from '@/lib/auth';

export default {
  data() {
    return {
      user: getUser() || {},
      loading: false,
      successMsg: '',
      errorMsg: '',
      form: {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
    };
  },
  methods: {
    async submit() {
      this.successMsg = '';
      this.errorMsg = '';

      if (this.form.newPassword !== this.form.confirmPassword) {
        this.errorMsg = 'New passwords do not match.';
        return;
      }
      if (this.form.newPassword.length < 6) {
        this.errorMsg = 'New password must be at least 6 characters.';
        return;
      }

      this.loading = true;
      try {
        await changePassword(this.form.currentPassword, this.form.newPassword);
        this.successMsg = 'Password changed successfully.';
        this.form.currentPassword = '';
        this.form.newPassword = '';
        this.form.confirmPassword = '';
      } catch (e) {
        this.errorMsg = e?.message || 'Failed to change password.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
